<form clrForm
      [formGroup]="editPositionsForm">
    <table class="table" id="positionsTable">
        <thead>
        <tr>
            <th class="left">Projekt</th>
            <th>Position</th>
            <th>Teil</th>
            <th class="left">Anzahl</th>
            <th class="left">Zeichnung</th>
            <th class="left">Bezeichnung</th>
            <th class="left">Material</th>
            <th class="left">Kennzeichnung</th>
            <th class="left">Chargen-Nr.</th>
            <th class="left">Kostenstelle</th>
            <th>Aktion</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="left">{{ positions[0].project_number }}</td>
            <td>{{ positions[0].position }}</td>
            <td><span *ngIf="editPart > 0">{{ editPart }}</span></td>
            <td><input *ngIf="!positions[0].technology" type="text" formControlName="number_of_pieces" placeholder="{{ positions[0].number_of_pieces }}" class="clr-input" value="{{ positions[0].number_of_pieces }}"></td>
            <td class="left">{{ positions[0].technical_drawing }}</td>
            <td class="left">{{ positions[0].name }}</td>
            <td class="left">{{ positions[0].material }}</td>
            <td class="left"><input type="text" formControlName="serial_nr" placeholder="{{ positions[0].serial_nr }} " class="clr-input" value="{{ positions[0].serial_nr }} "></td>
            <td class="left"><input type="text" formControlName="heat_nr" placeholder="{{ positions[0].heat_nr }}" class="clr-input" value="{{ positions[0].heat_nr }}"></td>
            <td class="left"><input type="text" formControlName="controlling_nr" placeholder="{{ positions[0].controlling_nr }}" class="clr-input" value="{{ positions[0].controlling_nr }}"></td>
            <td class="btn-group btn-primary btn-icon center">
                <button class="btn btn-sm" (click)="updatePosition()" [disabled]="editPositionsForm.invalid">
                    <cds-icon shape="floppy"></cds-icon>
                    <span class="clr-icon-title">Speichern</span>
                </button>
            </td>
        </tr>
        <tr *ngIf="positions[0].specification">
            <td colspan="5"></td>
            <td colspan="5" class="left">
                SPEZIFIKATION: {{ positions[0].specification }}
            </td>
            <td></td>
        </tr>
        <tr>
            <td colspan="4"></td>
            <td colspan="6" class="left">
                <div class="clr-form-control">
                    <label for="comment_phm" class="clr-control-label">Kommentare</label>
                    <div class="clr-control-container">
                        <div class="clr-textarea-wrapper">
                            <textarea formControlName="comment_phm" id="comment_phm" placeholder="{{ positions[0].comment_phm }}" cols="100" rows="3" class="clr-textarea" value="{{ positions[0].comment_phm }}"></textarea>
                            <clr-icon class="clr-validate-icon" shape="exclamation-circle"></clr-icon>
                        </div>
                        <span class="clr-subtext">Kommentar/Aufgabenstellung (projektbezogen) o.ä.</span>
                    </div>
                </div>
            </td>
            <td></td>
        </tr>
        </tbody>
    </table>
</form>

<br /><a class="btn btn-warning-outline btn-sm" (click)="cancelEdit()">Abbrechen</a>



